// extracted by mini-css-extract-plugin
export default {"container":"StandardSetsTable__container___ldsNX","feedContainer":"StandardSetsTable__feedContainer___S7zPE"};